import { defineStore } from 'pinia';
import api from '@/api';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    isLoading: true,
    profileSynced: false
  }),

  getters: {
    currentUser: (state) => state.user,
    isAuthenticated: (state) => !!state.user && !state.user?.expired,
    userProfile: (state) => state.user?.profile || null,
    accessToken: (state) => state.user?.access_token || null
  },

  actions: {
    setUser(user) {
      this.user = user;
      this.isLoading = false;
      this.syncProfile();
    },

    clearUser() {
      this.user = null;
      this.isLoading = false;
      this.profileSynced = false;
    },

    setLoading(loading) {
      this.isLoading = loading;
    },

    /**
     * Upserts this user's row in the operational backend (hr.t_user) so they
     * show up in operator/station assignment lists. Only invited users are
     * missing this row - it's never created there otherwise. Fire-and-forget,
     * once per session.
     */
    async syncProfile() {
      if (this.profileSynced || !this.user?.profile) return;
      this.profileSynced = true;
      try {
        await api.user.syncProfile({
          email: this.user.profile.email,
          displayName: this.user.profile.name,
          orgName: this.user.profile.orgName
        });
      } catch (e) {
        this.profileSynced = false;
      }
    }
  }
});
